import React, { useState} from 'react'
import { useStore } from '../../Store'

import { Box, FormControlLabel, TextField, MenuItem, Checkbox, Grid, Button } from '@material-ui/core';

const FeatureFilter = ({ filter:defaults, onSubmit, onCancel }) => {

    defaults.locatietype = defaults.locatietype || "-1";
    defaults.onderwerp = defaults.onderwerp || "-1";
    defaults.zoekmethode = defaults.zoekmethode || "-1";

    const [filter, setFilter]= useState(defaults)

    const { years, settings } = useStore()

    const seasons = years.map(item => { return (<MenuItem key={item.id} value={item.id}>{item.description}</MenuItem>) })

    const locatietype = [{ id: -1, value: '-1', name: 'alle' }, ...settings.lists['locatietype']]
        .map(item => { return (<MenuItem key={item.id} value={item.value}>{item.name}</MenuItem>) })
    
    const onderwerp = [{ id: -1, value: '-1', name: 'alle' }, ...settings.lists['onderwerp']]
        .map(item => { return (<MenuItem key={item.id} value={item.value}>{item.name}</MenuItem>) })

    const zoekmethode = [{ id: -1, value: '-1', name: 'alle' }, ...settings.lists['zoekmethode']]
        .map(item => { return (<MenuItem key={item.id} value={item.value}>{item.name}</MenuItem>) })

    const changeStartSeason = (e) => {
        const start= e.target.value
        const stop= (filter.stopSeasonId > start ? filter.stopSeasonId : start)
        setFilter({ ...filter, startSeasonId: start, stopSeasonId: stop })
    }
    const changeStopSeason = (e) => {
        const stop= e.target.value
        const start= (filter.startSeasonId < stop ? filter.startSeasonId : stop)
        setFilter({ ...filter, startSeasonId: start, stopSeasonId: stop })
    }

    const submit = () => {
        onSubmit(filter)
    }
        
    return (
        <Box m={2}>
        <Grid container>
            <Grid item xs={12}>
                <TextField select label="vanaf" variant="standard" name="startSeasonId" fullWidth value={filter.startSeasonId} onChange={changeStartSeason}>
                    {seasons}
                </TextField>
            </Grid>
            <Grid item xs={12}>
                <TextField select label="t/m" variant="standard" name="stopSeasonId" fullWidth value={filter.stopSeasonId} onChange={changeStopSeason}>
                    {seasons}
                </TextField>
            </Grid>
            <Grid item xs={12}>
                <TextField select label="locatietype" variant="standard" name="locatietype" fullWidth value={filter.locatietype} onChange={(e) => setFilter({...filter, locatietype:e.target.value})}>
                    {locatietype}
                </TextField>
            </Grid>
            <Grid item xs={12}>
                <TextField select label="wat gevonden?" variant="standard" name="onderwerp" fullWidth value={filter.onderwerp} onChange={(e) => setFilter({...filter, onderwerp:e.target.value})}>
                    {onderwerp}
                </TextField>
            </Grid>
            <Grid item xs={12}>
                <TextField select label="hoe waargenomen" variant="standard" name="zoekmethode" fullWidth value={filter.zoekmethode} onChange={(e) => setFilter({...filter, zoekmethode:e.target.value})}>
                    {zoekmethode}
                </TextField>
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel 
                    control={<Checkbox checked={filter.isObserver} onChange={(e) => setFilter({...filter, isObserver:e.target.checked})} />}
                    label="alleen eigen waarnemingen"
                />
            </Grid>
            <Grid item xs={6}>
                <Button variant="contained" color="primary" onClick={submit}>Filter</Button>
            </Grid>
            <Grid item xs={6}>
                <Button variant="contained" color="secondary" onClick={onCancel}>Sluiten</Button>
            </Grid>
        </Grid>
        </Box>
    )
}

export default FeatureFilter
